import type { TOC } from '@ember/component/template-only';

import didUpdate from 'webapp/modifiers/did-update';
import BarLoaderComponent from 'webapp/components/bar-loader';
import CommonRenderingPreviewHeaderComponent from 'webapp/components/common/rendering/preview-header';
import DatawallWallPasswordComponent from 'webapp/components/datawall/wall-password';
import DatawallWallsSliderComponent from 'webapp/components/datawall/walls-slider';
import ReportsPresentHelperComponent from 'webapp/components/reports/present-helper';
import ReportsViewerComponent from 'webapp/components/reports/viewer';
import ReportsViewerNavigationTogglerComponent from 'webapp/components/reports/viewer/navigation-toggler';
import type DatawallController from 'webapp/controllers/datawall';

interface Args {
	controller: DatawallController;
}

const DatawallRouteTemplate: TOC<Args> = <template>
	{{#if @controller.loadingReportInitialData}}
		<div class="main-loader">
			<div class="bar-container">
				<BarLoaderComponent />
			</div>

		</div>
	{{else if @controller.requirePassword}}
		<DatawallWallPasswordComponent
			@modelName={{@controller.modelName}}
			@onPassword={{@controller.verifyPassword}}
		/>
	{{else}}

		{{#if @controller.showHeader}}
			{{#if @controller.headerModel}}
				<CommonRenderingPreviewHeaderComponent
					@model={{@controller.headerModel}}
					@isEditBtnShown={{@controller.showEditInHeader}}
					@onEdit={{@controller.editModel}}
					@present={{@controller.initializePresentMode}}
					@buttonSize={{if @controller.isReport "small"}}
				/>
			{{/if}}
		{{/if}}

		{{#if @controller.isReport}}
			{{#if @controller.isLiveReport}}
				{{#unless @controller.isPagelessReport}}
					<ReportsViewerNavigationTogglerComponent
						@reportUIHelper={{@controller.reportUIHelperForLiveReport}}
						@color={{@controller.currentSlideColorForLiveReport}}
					/>
				{{/unless}}
			{{/if}}

			<ReportsViewerComponent
				@model={{@controller.report}}
				@selectedSlide={{@controller.currentVisibleSlide}}
				@onSlideChange={{@controller.onSlideChange}}
				@isLoaderShown={{@controller.isLoadingReportSlideData}}
			/>

			{{#if @controller.isLiveReport}}
				{{#if @controller.reportPresentManager}}
					<ReportsPresentHelperComponent @model={{@controller.reportPresentManager}} />
				{{/if}}
			{{/if}}

		{{else}}

			{{#unless @controller.hideSliderBeforeRerender}}
				<DatawallWallsSliderComponent
					@model={{@controller.boards}}
					@slideIndex={{@controller.currentSlideIndex}}
					@loopDelay={{@controller.boardLoop.loopDelay}}
					@hasHeader={{@controller.showHeader}}
					@hasFooter={{@controller.showIframeFooter}}
					@isTemplate={{@controller.isTemplate}}
					@showBottomSlider={{@controller.showBottomSlider}}
					@isInIframe={{@controller.previewUrlManager.isInIframe}}
					@showDesignerLink={{@controller.showDesignerLink}}
					@onBoardPreviewHashChange={{@controller.boardStatusHashChanged}}
					@onSlideChange={{@controller.onSlideChange}}
					@onToggleFullscreen={{@controller.toggleFullscreen}}
					@trackingOrigin="public_view"
				/>
			{{/unless}}

			{{#if @controller.previewUrlManager.isInIframe}}
				{{#if @controller.showIframeFooter}}
					<div id="cta">
						Get your free dashboard at
						<a
							href="{{@controller.requestService.websiteUrl}}/signup#embed"
							target="_blank"
						>

							Databox

						</a>
					</div>
				{{/if}}
			{{/if}}
		{{/if}}
	{{/if}}

	<span
		{{didUpdate
			@controller.checkIsPublicEnabled
			@controller.report.isPublicEnabled
			@controller.boardLoop.isPublicEnabled
			@controller.firstBoard.isPublicEnabled
		}}
	></span>
</template>;

export default DatawallRouteTemplate;
